<template>
  <ElButton
    type="danger"
    @click="showForm = true"
  >
    DELETE ACCOUNT

    <ElDialog
      append-to-body
      title="WARNING"
      top="25vh"
      :visible.sync="showForm"
    >
      <p>This action is not reversible.<br>Proceed with Caution!</p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          class="margin-right-unit"
          type="text"
          @click="showForm = false"
        >
          Cancel
        </ElButton>

        <ElButton
          type="danger"
          @click="deleteUser()"
        >
          Delete
        </ElButton>
      </span>
    </ElDialog>
  </ElButton>
</template>

<script>
import axios from '@/axios/axios'
import { GlobalEmitter } from '@/utils/GlobalEmitter'

export default {
  name: 'DeleteAccount',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showForm: false,
    }
  },
  methods: {
    deleteUser() {
      const data = {
        email: this.user.email
      }

      return axios.post('admin/user/delete', data)
        .then(res => {
          if (res.status === 200) {
            this.successNotification("User has been deleted")
            this.showForm = false
            GlobalEmitter.$emit('closePanel')
            GlobalEmitter.$emit("resetView")
          } 
          else {
            this.errorNotification("Something went wrong!")
          }
          
        })
        .catch(axios.handleError)
    }
  }
}
</script>
